import { render, useState, useEffect } from '@wordpress/element';
import Summaries from './Summaries.js';

const getSummariesPage = ({page}) => {

}


const TableHeader = ({fields}) => {

}



// Function to find the block and hydrate it with React
const init = () => {
    // Select all instances of your block
    const blocks = document.querySelectorAll('.nutritional_summaries');
    blocks.forEach((block) => {
        const restBaseUrl = block.dataset.resturl;
        render(
            <Summaries restBaseUrl={restBaseUrl} />,
            block
        );
    });
    // blocks.forEach((block) => {
    //     // Read the attributes from the data-* attributes
    //     const restBaseUrl = block.dataset.resturl;
    //     fetch( `${restBaseUrl}foodservices/nutrition_facts_fields` )
    //         .then( response => response.json() )
    //         .then( fields => {
    //             fetch( `${restBaseUrl}wp/v2/brand?per_page=100` )
    //                 .then( response => response.json() )
    //                 .then( brands => {
    //                     brands = brands.filter((brand) => brand.parent !=0);
    //                     render(
    //                         <Summaries fields={fields} brands={brands} restBaseUrl={restBaseUrl} />,
    //                         block
    //                     );
    //             });
                  
    //         });
    // });
};

// Wait for the DOM to be ready before initializing
document.addEventListener('DOMContentLoaded', init);


// import { render } from '@wordpress/element';
// import {Summaries} from './Summaries.js';

// document.addEventListener('DOMContentLoaded', () => {
//     console.log('view script');
//     const containers = document.querySelectorAll('.nutritional_summaries');
//     if (containers.length) {
//         const restBaseUrl = containers[0].dataset.resturl;

//         fetch( `${restBaseUrl}foodservices/nutrition_facts_fields` )
//             .then( response => response.json() )
//             .then( fields => {
//                 console.log(fields)
//             });
//     }       
    
//     containers.forEach(container => {
//         render(<Summaries />, container);
//     });
// });

